import { render, staticRenderFns } from "./partidaTracking.vue?vue&type=template&id=041b2092&scoped=true&"
import script from "./partidaTracking.vue?vue&type=script&lang=js&"
export * from "./partidaTracking.vue?vue&type=script&lang=js&"
import style0 from "./partidaTracking.vue?vue&type=style&index=0&id=041b2092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b2092",
  null
  
)

export default component.exports